import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { searchContent } from '@plone/volto/actions/search/search';
import { NEWS_NATIONAL_STATES } from 'volto-ministerio-publico-federal/constants';
import type { NewsItem } from './helpers';

/** Chave do subrequest de busca isolada para a capa. */
export const NEWS_SUBREQUEST = 'capa-news';

interface UseNewsSearchResult {
  items: NewsItem[];
  loading: boolean;
  loaded: boolean;
}

/**
 * Busca as últimas notícias (`@type: News`) para a capa via `@search`.
 *
 * Roda no cliente (useEffect); a renderização degrada graciosamente enquanto
 * carrega. `tema`/`unit_title` são expostos como metadata no `@search`.
 */
export function useNewsSearch(size = 5): UseNewsSearchResult {
  const dispatch = useDispatch();

  useEffect(() => {
    // searchContent vem do Volto (JS sem tipos) e retorna um Object; o dispatch
    // tipado espera AnyAction — castamos para satisfazer o type-check do CI.
    dispatch(
      searchContent(
        '',
        {
          portal_type: 'News',
          review_state: NEWS_NATIONAL_STATES,
          sort_on: 'effective',
          sort_order: 'descending',
          b_size: size,
          metadata_fields: [
            'tema',
            'unit_title',
            'effective',
            'image_scales',
            'image_field',
          ],
        },
        NEWS_SUBREQUEST,
      ) as any,
    );
  }, [dispatch, size]);

  const subrequest = useSelector(
    (state: any) => state.search?.subrequests?.[NEWS_SUBREQUEST],
  );

  return {
    items: subrequest?.items ?? [],
    loading: subrequest?.loading ?? false,
    loaded: subrequest?.loaded ?? false,
  };
}

export default useNewsSearch;
